/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AssignFormRequest,
    AssignFormRequestFromJSON,
    AssignFormRequestToJSON,
} from '../models/AssignFormRequest';
import {
    type InspectionFormResponse,
    InspectionFormResponseFromJSON,
    InspectionFormResponseToJSON,
} from '../models/InspectionFormResponse';
import {
    type ReassignFormRequest,
    ReassignFormRequestFromJSON,
    ReassignFormRequestToJSON,
} from '../models/ReassignFormRequest';
import {
    type SaveAnswersRequest,
    SaveAnswersRequestFromJSON,
    SaveAnswersRequestToJSON,
} from '../models/SaveAnswersRequest';
import {
    type SectionAnswerDto,
    SectionAnswerDtoFromJSON,
    SectionAnswerDtoToJSON,
} from '../models/SectionAnswerDto';
import {
    type UpdateFormStatusRequest,
    UpdateFormStatusRequestFromJSON,
    UpdateFormStatusRequestToJSON,
} from '../models/UpdateFormStatusRequest';

export interface AssignFormOperationRequest {
    /**
     * 
     */
    assignFormRequest: AssignFormRequest;
}

export interface GetAllFormsRequest {
    /**
     * Filter by status
     */
    status?: GetAllFormsStatusEnum;
    /**
     * Filter by machine ID
     */
    machineId?: string;
    /**
     * Filter by assigned operator (email)
     */
    assignedOperatorId?: string;
    /**
     * Only forms with no assigned operator
     */
    unassigned?: boolean;
}

export interface GetAnswersRequest {
    /**
     * Form instance ID
     */
    id: string;
}

export interface GetFormByIdRequest {
    /**
     * Form instance ID
     */
    id: string;
}

export interface GetFormsByOperatorRequest {
    /**
     * Operator ID
     */
    operatorId: string;
}

export interface ReassignFormOperationRequest {
    /**
     * Form instance ID
     */
    id: string;
    /**
     * 
     */
    reassignFormRequest: ReassignFormRequest;
}

export interface SaveAnswersOperationRequest {
    /**
     * Form instance ID
     */
    id: string;
    /**
     * 
     */
    saveAnswersRequest: SaveAnswersRequest;
}

export interface UpdateFormStatusOperationRequest {
    /**
     * Form instance ID
     */
    id: string;
    /**
     * 
     */
    updateFormStatusRequest: UpdateFormStatusRequest;
}

/**
 * 
 */
export class InspectionFormsApi extends runtime.BaseAPI {

    /**
     * Creates request options for assignForm without sending the request
     */
    async assignFormRequestOpts(requestParameters: AssignFormOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['assignFormRequest'] == null) {
            throw new runtime.RequiredError(
                'assignFormRequest',
                'Required parameter "assignFormRequest" was null or undefined when calling assignForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/forms/assign`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignFormRequestToJSON(requestParameters['assignFormRequest']),
        };
    }

    /**
     * Generates a new inspection form from the template\'s active published version and assigns it directly to the specified operator. This is a one-time action, not linked to any schedule. The form is created with PENDING status.
     * Assign a form to an operator (one-time)
     */
    async assignFormRaw(requestParameters: AssignFormOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionFormResponse>> {
        const requestOptions = await this.assignFormRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionFormResponseFromJSON(jsonValue));
    }

    /**
     * Generates a new inspection form from the template\'s active published version and assigns it directly to the specified operator. This is a one-time action, not linked to any schedule. The form is created with PENDING status.
     * Assign a form to an operator (one-time)
     */
    async assignForm(requestParameters: AssignFormOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionFormResponse> {
        const response = await this.assignFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAllForms without sending the request
     */
    async getAllFormsRequestOpts(requestParameters: GetAllFormsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['machineId'] != null) {
            queryParameters['machineId'] = requestParameters['machineId'];
        }

        if (requestParameters['assignedOperatorId'] != null) {
            queryParameters['assignedOperatorId'] = requestParameters['assignedOperatorId'];
        }

        if (requestParameters['unassigned'] != null) {
            queryParameters['unassigned'] = requestParameters['unassigned'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/forms`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists inspection form instances for admin management. Before listing, runs on-the-fly generation for any schedules currently due so newly-due forms appear immediately (no background poller required). Optional filters: status, machineId, assignedOperatorId, and unassigned=true (forms with no operator).
     * List all form instances (admin), with optional filters
     */
    async getAllFormsRaw(requestParameters: GetAllFormsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionFormResponse>> {
        const requestOptions = await this.getAllFormsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionFormResponseFromJSON(jsonValue));
    }

    /**
     * Lists inspection form instances for admin management. Before listing, runs on-the-fly generation for any schedules currently due so newly-due forms appear immediately (no background poller required). Optional filters: status, machineId, assignedOperatorId, and unassigned=true (forms with no operator).
     * List all form instances (admin), with optional filters
     */
    async getAllForms(requestParameters: GetAllFormsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionFormResponse> {
        const response = await this.getAllFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAnswers without sending the request
     */
    async getAnswersRequestOpts(requestParameters: GetAnswersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAnswers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/forms/{id}/answers`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieves all saved answers for a form instance. Returns an empty list if no answers have been saved yet.
     * Get saved answers
     */
    async getAnswersRaw(requestParameters: GetAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SectionAnswerDto>> {
        const requestOptions = await this.getAnswersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SectionAnswerDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves all saved answers for a form instance. Returns an empty list if no answers have been saved yet.
     * Get saved answers
     */
    async getAnswers(requestParameters: GetAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SectionAnswerDto> {
        const response = await this.getAnswersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getFormById without sending the request
     */
    async getFormByIdRequestOpts(requestParameters: GetFormByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getFormById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/forms/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieves a single inspection form instance by its identifier, including all sections with their questions, types, and threshold configurations.
     * Get form instance by ID
     */
    async getFormByIdRaw(requestParameters: GetFormByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionFormResponse>> {
        const requestOptions = await this.getFormByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionFormResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a single inspection form instance by its identifier, including all sections with their questions, types, and threshold configurations.
     * Get form instance by ID
     */
    async getFormById(requestParameters: GetFormByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionFormResponse> {
        const response = await this.getFormByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getFormsByOperator without sending the request
     */
    async getFormsByOperatorRequestOpts(requestParameters: GetFormsByOperatorRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['operatorId'] == null) {
            throw new runtime.RequiredError(
                'operatorId',
                'Required parameter "operatorId" was null or undefined when calling getFormsByOperator().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/forms/operator/{operatorId}`;
        urlPath = urlPath.replace('{operatorId}', encodeURIComponent(String(requestParameters['operatorId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieves all inspection form instances assigned to a specific operator, ordered by generation time. Includes sections for each form.
     * Get form instances by operator ID
     */
    async getFormsByOperatorRaw(requestParameters: GetFormsByOperatorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionFormResponse>> {
        const requestOptions = await this.getFormsByOperatorRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionFormResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all inspection form instances assigned to a specific operator, ordered by generation time. Includes sections for each form.
     * Get form instances by operator ID
     */
    async getFormsByOperator(requestParameters: GetFormsByOperatorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionFormResponse> {
        const response = await this.getFormsByOperatorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for reassignForm without sending the request
     */
    async reassignFormRequestOpts(requestParameters: ReassignFormOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling reassignForm().'
            );
        }

        if (requestParameters['reassignFormRequest'] == null) {
            throw new runtime.RequiredError(
                'reassignFormRequest',
                'Required parameter "reassignFormRequest" was null or undefined when calling reassignForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/forms/{id}/assign`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ReassignFormRequestToJSON(requestParameters['reassignFormRequest']),
        };
    }

    /**
     * Assigns or reassigns an already-generated form instance to an operator (by email) and optionally sets its due date. Status, snapshot and answers are unchanged. Reassigning a COMPLETED or CANCELLED form is rejected.
     * Reassign an existing form to an operator
     */
    async reassignFormRaw(requestParameters: ReassignFormOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionFormResponse>> {
        const requestOptions = await this.reassignFormRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionFormResponseFromJSON(jsonValue));
    }

    /**
     * Assigns or reassigns an already-generated form instance to an operator (by email) and optionally sets its due date. Status, snapshot and answers are unchanged. Reassigning a COMPLETED or CANCELLED form is rejected.
     * Reassign an existing form to an operator
     */
    async reassignForm(requestParameters: ReassignFormOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionFormResponse> {
        const response = await this.reassignFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for saveAnswers without sending the request
     */
    async saveAnswersRequestOpts(requestParameters: SaveAnswersOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling saveAnswers().'
            );
        }

        if (requestParameters['saveAnswersRequest'] == null) {
            throw new runtime.RequiredError(
                'saveAnswersRequest',
                'Required parameter "saveAnswersRequest" was null or undefined when calling saveAnswers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/forms/{id}/answers`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveAnswersRequestToJSON(requestParameters['saveAnswersRequest']),
        };
    }

    /**
     * Saves answers for a form instance (partial or complete). Can be called multiple times — existing answers for the same section are updated (upsert). Automatically transitions PENDING forms to IN_PROGRESS on first save. Rejects saves on COMPLETED or CANCELLED forms.
     * Save answers
     */
    async saveAnswersRaw(requestParameters: SaveAnswersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SectionAnswerDto>> {
        const requestOptions = await this.saveAnswersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SectionAnswerDtoFromJSON(jsonValue));
    }

    /**
     * Saves answers for a form instance (partial or complete). Can be called multiple times — existing answers for the same section are updated (upsert). Automatically transitions PENDING forms to IN_PROGRESS on first save. Rejects saves on COMPLETED or CANCELLED forms.
     * Save answers
     */
    async saveAnswers(requestParameters: SaveAnswersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SectionAnswerDto> {
        const response = await this.saveAnswersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateFormStatus without sending the request
     */
    async updateFormStatusRequestOpts(requestParameters: UpdateFormStatusOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateFormStatus().'
            );
        }

        if (requestParameters['updateFormStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFormStatusRequest',
                'Required parameter "updateFormStatusRequest" was null or undefined when calling updateFormStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/forms/{id}/status`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFormStatusRequestToJSON(requestParameters['updateFormStatusRequest']),
        };
    }

    /**
     * Updates the status of an inspection form instance. Valid transitions are: PENDING→IN_PROGRESS, PENDING→OVERDUE, IN_PROGRESS→COMPLETED, OVERDUE→CANCELLED, OVERDUE→IN_PROGRESS. Invalid transitions return 422 Unprocessable Entity. Transitioning to COMPLETED automatically sets the completedAt timestamp.
     * Update form instance status
     */
    async updateFormStatusRaw(requestParameters: UpdateFormStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionFormResponse>> {
        const requestOptions = await this.updateFormStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionFormResponseFromJSON(jsonValue));
    }

    /**
     * Updates the status of an inspection form instance. Valid transitions are: PENDING→IN_PROGRESS, PENDING→OVERDUE, IN_PROGRESS→COMPLETED, OVERDUE→CANCELLED, OVERDUE→IN_PROGRESS. Invalid transitions return 422 Unprocessable Entity. Transitioning to COMPLETED automatically sets the completedAt timestamp.
     * Update form instance status
     */
    async updateFormStatus(requestParameters: UpdateFormStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionFormResponse> {
        const response = await this.updateFormStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetAllFormsStatusEnum = {
    Pending: 'PENDING',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Overdue: 'OVERDUE',
    Cancelled: 'CANCELLED',
} as const;
export type GetAllFormsStatusEnum = typeof GetAllFormsStatusEnum[keyof typeof GetAllFormsStatusEnum];
